// Module
var code = " <div class=\"search-list-view\"> <div class=\"col-md-12\"> <div class=\"row\"> <div class=\"col-md-12\"> <dv-quicksearch-list antraege=\"vm.getSearchList()\" items-by-page=\"20\" initial-all=\"true\" show-selection-all=\"true\" table-title=\"'SEARCH_LIST'\" table-id=\"searchTable\"> </dv-quicksearch-list> </div> </div> </div> </div> ";
// Exports
module.exports = code;